"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = {
    name: "required_checkbox",
    isImplicit: true,
    errorMessage: "You should select at least one of the options.",
    validate: function (value) { return value !== undefined && value !== null && value !== ""; },
};
